/**
 * @fileoverview Overall component for the Summary launch step.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */

import {LicenseAssignmentTable} from '/src/com/yext/listingslaunchstorm/js/enterprise/summary/licenseassignmenttable';
import {ListingsSetupTable} from '/src/com/yext/listingslaunchstorm/js/enterprise/summary/listingssetuptable';
import {PublisherSetupTable} from '/src/com/yext/listingslaunchstorm/js/enterprise/summary/publishersetuptable';
import {EnterpriseConfiguration} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/enterpriseconfiguration';

import * as styles from '/src/com/yext/listingslaunchstorm/js/enterprise/summary/summary.module.scss';

/**
 * @param {{
 *   enterpriseConfiguration: EnterpriseConfiguration,
 *   onViewStep: function(string): void,
 *   publisherIds: Array<number>,
 * }} props
 * @returns {React.ReactNode}
 */
export function Summary({
  enterpriseConfiguration,
  onViewStep,
  publisherIds,
}) {
  return (
    <div className={styles.page}>
      <div>
        <div className={styles.header}>{yext.msg('Listings Setup')}</div>
        <ListingsSetupTable
          enterpriseConfiguration={enterpriseConfiguration}
          onViewStep={onViewStep}
          publisherIds={publisherIds}
        />
      </div>
      {publisherIds.length > 0
      && <div>
        <div className={styles.header}>{yext.msg('Publisher Setup')}</div>
        <PublisherSetupTable
          enterpriseConfiguration={enterpriseConfiguration}
          onViewStep={onViewStep}
          publisherIds={publisherIds}
        />
      </div>}
      <div>
        <div className={styles.header}>{yext.msg('License Assignment')}</div>
        <LicenseAssignmentTable
          enterpriseConfiguration={enterpriseConfiguration}
          onViewStep={onViewStep}
        />
      </div>
    </div>
  );
}
